import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    display: 'flex',
  },
  iconButton: {
    padding: [12, 16, 12, 0],
    [theme.breakpoints.up('mobile')]: {
      display: 'none',
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/Title/useStyles.js